// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"34fd6384","455":"d492e610"}[chunkId] + ".chunk.js";
};